export enum NUDGES_TYPE {
    JoinRewardProgramTemplate = "JOIN_REWARD_PROGRAM",
    PointsSpendingTemplate = "POINT_SPENDING",
    RewardAvailableTemplate = "REWARD_AVAILABLE",
}

export enum CTAW_TYPE {
    BUTTON_LINK = "BUTTON_LINK",
    LOGIN_OR_SIGN_UP = "LOGIN_OR_SIGN_UP",
    BUTTON_REDEEM_REWARD = "BUTTON_REDEEM_REWARD",
    BUTTON_APPLY_DISCOUNT = "BUTTON_APPLY_DISCOUNT",
}

export interface RewardsCustomerSelectValueInterface {
    itemId: number;
    type: REWARDS_REWARD_TYPES;
    code: string;
    variantId?: number;
}

export enum REWARDS_REWARD_TYPES {
    points = "points",
    discount = "discount",
    giftCard = "gift_card",
    freeProduct = "free_product",
}

export enum REWARDS_DISCOUNT_TYPE {
    REWARD = "reward",
    REDEEM = "redeem",
    TIER = "tier",
    REFERRED = "referred",
    REFERRER = "referrer",
}

export enum NUDGES_ICON_SIZES {
    small = "sm", // 60x60
    medium = "md", // 360x180
    large = "lg", // 720x360
    extraLarge = "xlg", // 1024x768
}
